import { useEffect, useRef } from "react";

export type SlashItem = {
  id: string;
  label: string;
  hint: string;
  run: () => void;
};

type Props = {
  items: SlashItem[];
  top: number;
  left: number;
  onClose: () => void;
};

export function SlashMenu({ items, top, left, onClose }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const idx = useRef(0);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose();
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        idx.current = Math.min(items.length - 1, idx.current + 1);
        highlight();
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        idx.current = Math.max(0, idx.current - 1);
        highlight();
      }
      if (e.key === "Enter") {
        e.preventDefault();
        items[idx.current]?.run();
      }
    }
    function highlight() {
      const nodes = ref.current?.querySelectorAll("[data-slash-item]");
      nodes?.forEach((n, i) => n.classList.toggle("active", i === idx.current));
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [items, onClose]);

  return (
    <div className="slash-menu" ref={ref} style={{ top, left }} role="listbox">
      {items.map((it, i) => (
        <button
          key={it.id}
          type="button"
          data-slash-item
          className={i === 0 ? "active" : ""}
          onClick={() => it.run()}
        >
          <span className="slash-label">{it.label}</span>
          {it.hint ? <span className="slash-hint">{it.hint}</span> : null}
        </button>
      ))}
    </div>
  );
}
